import axios from 'axios';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Flag,
  Icon,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableCell,
  Grid,
  GridRow,
  GridColumn,
  Card,
  CardGroup,
  CardHeader,
  CardContent,
  StatisticGroup,
  Statistic,
  StatisticLabel,
  StatisticValue,
} from 'semantic-ui-react';

import { compose } from 'recompose';
import _ from 'lodash';
import hasRESTClient from '../../hocs/has-rest-client';
import withUserInfo from '../../hocs/has-user-info';
import CampaignReportCard from '../../components/campaign-report-card';


const delay = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));

const reportsMonths = ['AUGUST'];

const boxStyle = {
  paddingTop: 19,
  paddingBottom: 19,
};

const STATS_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com';
const LINK_STATS_API = `${STATS_API}/production/abbottlyon/short.io/stats/clicks`;
const CAMPAIGN_STATS_API = `${STATS_API}/production/abbottlyon/short.io/stats/campaigns`;

class AbbottLyonDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      augustReports: [],
      augustIsLoading: false,
      augustIsReloading: false,
      groupView: true,
      linkStats: null,
      campaignStats: null,
    };
    const { buildRESTClient } = this.props;
    this.reportImportClient = buildRESTClient({
      baseURL: process.env.REACT_APP_SHARE_API_URL || '',
      hasToken: false,
      timeout: 100000,
    });
  }


toggleGroupView = () => {
  this.setState(prev => ({ groupView: !prev.groupView }));
}
groupReports = reports => {
  const groupped = _.groupBy(reports, 'name');
  return _.reduce(_.values(groupped), (acc, group) => {
    const result = {};
    const first = group[0];
    _.forEach(_.keys(first), key => {
      result[key] = _.isNumber(first[key]) ? _.sumBy(group, key) : first[key];
    });
    acc.push(result);
    return acc;
  }, []);
}
  fetchReportForMonth = async (month, reloading = false) => {
    const loadingStateKey = reloading ? `${_.toLower(month)}IsReloading` : `${_.toLower(month)}IsLoading`;
    this.setState({
      [loadingStateKey]: true,
    });
    const { userInfo: { organisationId } } = this.props;
    const params = reloading ? { clearCache: true } : {};
    await this.reportImportClient.get(`/organisation/${organisationId}/report/${month}`, { params }).then(response => {
      const reports = _.get(response, 'data.data.data.reports', []);

      const groupedReports = this.groupReports(reports);
      this.setState({
        [`${_.toLower(month)}Reports`]: _.sortBy(reports, 'name'),
        [`${_.toLower(month)}ReportsGrouped`]: _.sortBy(groupedReports, 'name'),
        [loadingStateKey]: false,
      });
    }).catch(err => {
      this.setState({
        [`${_.toLower(month)}Reports`]: [],
        [`${_.toLower(month)}ReportsGrouped`]: [],
        [loadingStateKey]: false,
      });
    });
  }
  fetchReports = async () => {
    this.setState({
      augustIsLoading: true,
    });
    // eslint-disable-next-line no-restricted-syntax
    for (const month of reportsMonths) {
      // eslint-disable-next-line no-await-in-loop
      await this.fetchReportForMonth(month);
      delay(500);
    }
  }

  fetchLinkStats = async () => {
    const period = 'last7';
    const response = await axios.get(`${LINK_STATS_API}/${period}`);

    const { pathData, campaignData } = response.data;

    const orderedCampaigns = _.map(campaignData, (v, k) => ({ campaign: k, clicks: v.count }));

    console.log(orderedCampaigns);

    const ordered = _.orderBy(pathData, 'clicks');

    _.forEach(ordered, o => {
      if (_.startsWith(o.path, '/tt/')) {
        const handle = _.replace(o.path, '/tt/', '');
        o.handle = handle;
        o.href = `https://tiktok.com/@${handle}`;
      } else {
        const handle = _.replace(o.path, '/ig/', '');
        o.handle = handle;
        o.href = `https://instagram.com/${handle}`;
      }
    });
    this.setState({
      linkStats: _.reverse(ordered),
      campaignStats: _.reverse(_.orderBy(orderedCampaigns, 'clicks')),
    });
  }

  fetchCampaignStats = async () => {
    const period = 'last7';
    const response = await axios.get(`${CAMPAIGN_STATS_API}/${period}`);

    const rawData = response.data;

    const filtered = _.filter(rawData, d => (d.displayName.length > 1));
    this.setState({
      campaignStats: filtered,
    });
  }

  componentDidMount() {
    this.fetchReports();
    this.fetchLinkStats();
    //    this.fetchCampaignStats();
  }


  render() {
    const {
      augustReports,
      augustReportsGrouped,
      augustIsLoading,
      augustIsReloading,
      groupView,
      linkStats,
      campaignStats,
    } = this.state;

    console.log(linkStats);

    const totals = {};

    if (augustReports) {
      totals.ukInsta = _.sumBy(augustReports, ar => {
        if (ar.country === 'GB' && ar.name.match(/instagram/i)) return ar.influencers;
        return 0;
      });
      totals.linksUkInsta = _.sumBy(linkStats, ls => {
        if (ls.campaign.match(/^UK-INSTAGRAM/i)) return 1;
        return 0;
      });
      totals.ukTikTok = _.sumBy(augustReports, ar => {
        if (ar.country === 'GB' && ar.name.match(/tiktok/i)) return ar.influencers;
        return 0;
      });
      totals.linksUkTikTok = _.sumBy(linkStats, ls => {
        if (ls.campaign.match(/^UK-TIKTOK/i)) return 1;
        return 0;
      });
      totals.usTikTok = _.sumBy(augustReports, ar => {
        if (ar.country === 'US' && ar.name.match(/tiktok/i)) return ar.influencers;
        return 0;
      });
      totals.linksUsTikTok = _.sumBy(linkStats, ls => {
        if (ls.campaign.match(/^US-TIKTOK/i)) return 1;
        return 0;
      });
      totals.usInsta = _.sumBy(augustReports, ar => {
        if (ar.country === 'US' && ar.name.match(/instagram/i)) return ar.influencers;
        return 0;
      });
      totals.linksUsInsta = _.sumBy(linkStats, ls => {
        if (ls.campaign.match(/^US-INSTAGRAM/i)) return 1;
        return 0;
      });
    }

    console.log(totals);
    return (
      <div className="page">
        <div className="influencer-context-bar" style={boxStyle}>
          <div className="spacer small" />
          <div className="flex">
            <div className="item">
              <h1>Dashboard</h1>
            </div>
            <div className="space" />
          </div>
          <div className="flex" >
            <div className="item">
              <h3 className="light">Abbott Lyon</h3>
            </div>
            <div className="item">
              <div className="horizontal-spacer" />
            </div>
            <div className="space" />
          </div>
        </div>
        <div className="page-content">
          <div>
            <CampaignReportCard
              campaigns={groupView ? augustReportsGrouped : augustReports}
              title="August"
              month="AUGUST"
              isLoading={augustIsLoading}
              onReload={this.fetchReportForMonth}
              isReloading={augustIsReloading}
              onGroupViewToggle={this.toggleGroupView}
            />


            <Card fluid>
              <CardContent>
                <CardHeader>Affiliate Link Clicks (last 7 days)</CardHeader>
              </CardContent>

              <CardContent>

                <CardGroup itemsPerRow="2">
                  <Card>
                    <CardContent header>
                      <h3 style={{ textAlign: 'center' }}>
                        <Flag name="gb" />
                        UK CAMPAIGNS
                      </h3>
                    </CardContent>
                    <Card.Content>
                      <StatisticGroup size="large" widths="2">
                        <Statistic color="blue">
                          <StatisticValue>
                            <Icon name="camera retro" size="tiny" />&nbsp;
                            {totals ? `${Math.round((totals.linksUkInsta / totals.ukInsta) * 100)}%` : '...'}
                          </StatisticValue>
                          <StatisticLabel>UK INSTAGRAM</StatisticLabel>
                        </Statistic>
                        <Statistic color="blue">
                          <StatisticValue>
                            <Icon name="music" size="tiny" />&nbsp;
                            {totals ? `${Math.round((totals.linksUkTikTok / totals.ukTikTok) * 100)}%` : '...'}
                          </StatisticValue>
                          <StatisticLabel>UK TIKTOK</StatisticLabel>
                        </Statistic>
                      </StatisticGroup>
                    </Card.Content>
                    <Card.Content>
                      <table width="100%" style={{ textAlign: 'center' }} >
                        <tr>
                          <td width="50%">
                            {totals.linksUkInsta} of {totals.ukInsta}
                          </td>
                          <td width="50%">
                            {totals.linksUkTikTok} of {totals.ukTikTok}
                          </td>
                        </tr>
                      </table>
                    </Card.Content>
                  </Card>
                  <Card>
                    <CardContent header>
                      <h3 style={{ textAlign: 'center' }}>
                        <Flag name="us" />
                        US CAMPAIGNS
                      </h3>
                    </CardContent>
                    <Card.Content>
                      <StatisticGroup size="large" widths="2">
                        <Statistic color="pink">
                          <StatisticValue>
                            <Icon name="camera retro" size="tiny" />&nbsp;
                            {totals ? `${Math.round((totals.linksUsInsta / totals.usInsta) * 100)}%` : '...'}
                          </StatisticValue>
                          <StatisticLabel>US INSTAGRAM</StatisticLabel>
                        </Statistic>
                        <Statistic color="pink">
                          <StatisticValue>
                            <Icon name="music" size="tiny" />&nbsp;
                            {totals ? `${Math.round((totals.linksUsTikTok / totals.usTikTok) * 100)}%` : '...'}
                          </StatisticValue>
                          <StatisticLabel>US TIKTOK</StatisticLabel>
                        </Statistic>

                      </StatisticGroup>
                    </Card.Content>
                    <Card.Content>
                      <table width="100%" style={{ textAlign: 'center' }} >
                        <tr>
                          <td width="50%">
                            {totals.linksUsInsta} of {totals.usInsta}
                          </td>
                          <td width="50%">
                            {totals.linksUsTikTok} of {totals.usTikTok}
                          </td>
                        </tr>
                      </table>
                    </Card.Content>
                  </Card>

                </CardGroup>

                <Grid columns={2}>
                  <GridRow>
                    <GridColumn>
                      { linkStats &&
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHeaderCell>Link</TableHeaderCell>
                            <TableHeaderCell>Campaign</TableHeaderCell>
                            <TableHeaderCell>Clicks</TableHeaderCell>
                          </TableRow>
                        </TableHeader>

                        <TableBody>
                          {
                            _.map(linkStats, ls => (
                              <TableRow>
                                <TableCell>
                                  <a href={ls.href} target="_blank"> {ls.path}</a>
                                </TableCell>
                                <TableCell>
                                  {ls.campaign}
                                </TableCell>
                                <TableCell>
                                  {ls.clicks}
                                </TableCell>
                              </TableRow>
                            ))
                          }
                        </TableBody>
                      </Table>
                      }
                    </GridColumn>
                    <GridColumn>

                      { campaignStats &&
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHeaderCell>Campaign</TableHeaderCell>
                            <TableHeaderCell>Clicks</TableHeaderCell>
                          </TableRow>
                        </TableHeader>
                        <TableBody>

                          {
                            _.map(campaignStats, cs => (
                              <TableRow>
                                <TableCell>{cs.campaign}</TableCell>
                                <TableCell>{cs.clicks}</TableCell>
                              </TableRow>
                            ))
                          }

                        </TableBody>
                      </Table>
                      }
                    </GridColumn>
                  </GridRow>
                </Grid>

              </CardContent>

            </Card>

          </div>
        </div>
      </div>
    );
  }
}

AbbottLyonDashboard.propTypes = {
  buildRESTClient: PropTypes.func.isRequired,
};
export default compose(
  hasRESTClient,
  withUserInfo,
)(AbbottLyonDashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/abbott-lyon-dashboard/index.js
 **/